import {
    GENERAL_SETTING,
    POS_ADD_TO_CART,
    POS_REMOVE_FROM_CART,
    POS_UPDATE_TO_CART_ITEM_QUANTITY,
    POS_ADD_TO_ORDER_DISCOUNT,
    POS_REMOVE_ORDER,
    POS_UPDATE_TO_ORDER,
    TABLE_ADD_TO_CART,
    TABLE_REMOVE_FROM_CART,
    TABLE_UPDATE_TO_CART_ITEM_QUANTITY,
    TABLE_REMOVE_ORDER,
    TABLE_UPDATE_TO_ORDER,
    TABLE_SIDE_DRAWER,
    ADMIN_SIDE_DRAWER,
    DEVICE_TOKEN,
} from '@/store/action-types';
import Moment from 'moment';

const initialState = {
    generalSetting: {},
    todayDateUpdate: '',
    tableSideDrawer: false,
    adminSideDrawer: true,
    deviceToken: '',
    posOrder: {
        token: '',
        user_id: '',
        subtotal: 0,
        total_tax: 0,
        discount: 0,
        delivery_charge: 0,
        total: 0,
        order_type: 1,
        payment_method_id: '',
        preparation_time: '',
        cartItems: [],
    },
    tableOrder: {
        token: '',
        user_id: '',
        subtotal: 0,
        discount: 0,
        delivery_charge: 0,
        total: 0,
        order_type: 2,
        payment_method_id: '',
        dining_table_id: '',
        preparation_time: '',
        account_number: '',
        cartItems: [],
    },
};

const GeneralSetting = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case GENERAL_SETTING:
            return generalSetting(state, payload);
        case DEVICE_TOKEN:
            return setDeviceToken(state, payload);
        case TABLE_SIDE_DRAWER:
            return setTableSideDrawer(state, payload);
        case ADMIN_SIDE_DRAWER:
            return setAdminSideDrawer(state, payload);
        case POS_ADD_TO_CART:
            return addOrUpdateCartItemPOS(state, payload);
        case POS_UPDATE_TO_CART_ITEM_QUANTITY:
            return updateCartItemQuantityPOS(state, payload);
        case POS_ADD_TO_ORDER_DISCOUNT:
            return addToOrderDiscountPOS(state, payload);
        case POS_UPDATE_TO_ORDER:
            return updateOrderPOS(state, payload);
        case POS_REMOVE_FROM_CART:
            return removeFromCartPOS(state, payload);
        case POS_REMOVE_ORDER:
            return removeOrderPOS(state, payload);
        case TABLE_ADD_TO_CART:
            return addOrUpdateCartItemTable(state, payload);
        case TABLE_UPDATE_TO_CART_ITEM_QUANTITY:
            return updateCartItemQuantityTable(state, payload);
        case TABLE_UPDATE_TO_ORDER:
            return updateOrderTable(state, payload);
        case TABLE_REMOVE_FROM_CART:
            return removeFromCartTable(state, payload);
        case TABLE_REMOVE_ORDER:
            return removeOrderTable(state, payload);
        default:
            return state;
    }
};

const generalSetting = (state, payload) => {
    state = Object.assign({}, state, {
        cartItems: [],
        generalSetting: payload?.data,
        todayDateUpdate: Moment.utc().format('DD/MM/YYYY'),
    });
    return state;
};

const setDeviceToken = (state, payload) => {
    state = Object.assign({}, state, {
        deviceToken: payload,
    });
    return state;
};

const setTableSideDrawer = (state, payload) => {
    state = Object.assign({}, state, {
        tableSideDrawer: !state.tableSideDrawer,
    });
    return state;
};

const setAdminSideDrawer = (state, payload) => {
    state = Object.assign({}, state, {
        adminSideDrawer: !state.adminSideDrawer,
    });
    return state;
};

// pos order
const addOrUpdateCartItemPOS = (state, payload) => {
    const existingItemIndex =
        state.posOrder?.cartItems &&
        state.posOrder?.cartItems.length > 0 &&
        state.posOrder?.cartItems?.findIndex(
            (item) =>
                item._id === payload._id &&
                JSON.stringify(item?.item_variations?._ids?.sort()) === JSON.stringify(payload?.item_variations?._ids?.sort()) &&
                JSON.stringify(item?.item_extras?._ids?.sort()) === JSON.stringify(payload?.item_extras?._ids?.sort())
        );

    if (state.posOrder?.cartItems && state.posOrder?.cartItems.length > 0 && existingItemIndex !== -1) {
        // Update quantity if item already exists in the cart
        // Add the quantity from payload to existing quantity
        const payloadQuantity = Math.max(1, Math.floor(parseFloat(payload?.quantity)) || 1);
        const updatedCartItems = state.posOrder?.cartItems.map((item, index) => {
            if (index === existingItemIndex) {
                const updatedQuantity = (item?.quantity || 0) + payloadQuantity;
                // Use payload price (which may have updated variations/extras) or fall back to existing price
                const itemPricePerUnit = payload?.price || item?.price || 0;
                const totalPrice = itemPricePerUnit * updatedQuantity;

                return {
                    ...item,
                    // Update price, tax, and variations/extras from payload if they changed
                    price: itemPricePerUnit,
                    tax_amount: payload?.tax_amount !== undefined ? payload.tax_amount : item?.tax_amount,
                    tax_rate: payload?.tax_rate !== undefined ? payload.tax_rate : item?.tax_rate,
                    tax_name: payload?.tax_name !== undefined ? payload.tax_name : item?.tax_name,
                    tax_code: payload?.tax_code !== undefined ? payload.tax_code : item?.tax_code,
                    item_variations: payload?.item_variations || item?.item_variations,
                    item_variation_total: payload?.item_variation_total !== undefined ? payload.item_variation_total : item?.item_variation_total,
                    item_extras: payload?.item_extras || item?.item_extras,
                    item_extra_total: payload?.item_extra_total !== undefined ? payload.item_extra_total : item?.item_extra_total,
                    quantity: updatedQuantity,
                    total_price: totalPrice,
                };
            }
            return item;
        });

        // Calculate subtotal (without tax) - items already have tax_amount = 0
        const subtotal = updatedCartItems.reduce((sum, item) => {
            return sum + (item.total_price || 0);
        }, 0);
        
        // Calculate tax on total subtotal using the highest tax rate from items
        const taxRates = updatedCartItems
            .map(item => {
                const rate = parseFloat(item?.tax_rate);
                return isNaN(rate) ? 0 : rate;
            })
            .filter(rate => rate > 0);
        const maxTaxRate = taxRates.length > 0 ? Math.max(...taxRates) : 0;
        const totalTax = subtotal > 0 && maxTaxRate > 0 ? (subtotal * maxTaxRate) / 100 : 0;
        const total = subtotal + totalTax - (state.posOrder?.discount || 0) + (state.posOrder?.delivery_charge || 0);

        state = Object.assign({}, state, {
            posOrder: {
                ...state.posOrder,
                cartItems: updatedCartItems,
                subtotal: parseFloat(subtotal).toFixed(2),
                total_tax: parseFloat(totalTax).toFixed(2),
                total: parseFloat(total).toFixed(2),
                discount: 0,
                delivery_charge: 0,
            },
        });
    } else {
        // Add new item to the cart
        state = Object.assign({}, state, {
            posOrder: {
                ...state.posOrder,
                cartItems: [...(state.posOrder?.cartItems || []), { ...payload }],
            },
        });

        // Calculate subtotal (without tax) - items already have tax_amount = 0
        const subtotal = state.posOrder.cartItems.reduce((sum, item) => {
            return sum + (item.total_price || 0);
        }, 0);
        
        // Calculate tax on total subtotal using the highest tax rate from items
        const taxRates = state.posOrder.cartItems
            .map(item => {
                const rate = parseFloat(item?.tax_rate);
                return isNaN(rate) ? 0 : rate;
            })
            .filter(rate => rate > 0);
        const maxTaxRate = taxRates.length > 0 ? Math.max(...taxRates) : 0;
        const totalTax = subtotal > 0 && maxTaxRate > 0 ? (subtotal * maxTaxRate) / 100 : 0;
        const total = subtotal + totalTax - (state.posOrder?.discount || 0) + (state.posOrder?.delivery_charge || 0);

        // Update state with recalculated values
        state = Object.assign({}, state, {
            posOrder: {
                ...state.posOrder,
                subtotal: parseFloat(subtotal).toFixed(2),
                total_tax: parseFloat(totalTax).toFixed(2),
                total: parseFloat(total).toFixed(2),
                discount: 0,
                delivery_charge: 0,
            },
        });
    }

    return state;
};

const updateCartItemQuantityPOS = (state, payload) => {
    // Validate payload
    if (!payload || !payload._id || payload.index === undefined || !payload.quantity) {
        return state;
    }

    // Ensure quantity is a valid positive number
    const newQuantity = Math.max(1, Math.floor(parseFloat(payload.quantity)) || 1);
    
    const existingItemIndex = state.posOrder?.cartItems?.findIndex((item, index) => item._id === payload._id && index === payload.index);
    
    // If item not found, return state unchanged
    if (existingItemIndex === -1) {
        return state;
    }

    // Update the cart item with the new quantity directly
    const updatedCartItems = state.posOrder?.cartItems?.map((item, index) => {
        if (index === existingItemIndex) {
            // Recalculate total_price with tax included
            const itemPricePerUnit = item?.price || 0;
            const totalPrice = itemPricePerUnit * newQuantity;

            return {
                ...item,
                quantity: newQuantity,
                total_price: totalPrice,
            };
        }
        return item;
    });

    // Calculate subtotal (without tax) - items already have tax_amount = 0
    const subtotal = updatedCartItems.reduce((sum, item) => {
        return sum + (item.total_price || 0);
    }, 0);
    
    // Calculate tax on total subtotal using the highest tax rate from items
    const taxRates = updatedCartItems
        .map(item => {
            const rate = parseFloat(item?.tax_rate);
            return isNaN(rate) ? 0 : rate;
        })
        .filter(rate => rate > 0);
    const maxTaxRate = taxRates.length > 0 ? Math.max(...taxRates) : 0;
    const totalTax = subtotal > 0 && maxTaxRate > 0 ? (subtotal * maxTaxRate) / 100 : 0;
    const total = subtotal + totalTax - (state.posOrder?.discount || 0) + (state.posOrder?.delivery_charge || 0);

    state = Object.assign({}, state, {
        posOrder: {
            ...state.posOrder,
            cartItems: updatedCartItems,
            subtotal: parseFloat(subtotal).toFixed(2),
            total_tax: parseFloat(totalTax).toFixed(2),
            total: parseFloat(total).toFixed(2),
            discount: state.posOrder?.discount || 0,
            delivery_charge: state.posOrder?.delivery_charge || 0,
        },
    });
    return state;
};

const addToOrderDiscountPOS = (state, payload) => {
    const updatedCartItems = state.posOrder?.cartItems;

    const discount = parseFloat(payload?.discount).toFixed(2);
    // Calculate updated subtotal (without tax) - items already have tax_amount = 0
    const subtotal = updatedCartItems.reduce((sum, item) => {
        return sum + (item.total_price || 0);
    }, 0);
    
    // Calculate tax on total subtotal using the highest tax rate from items
    const taxRates = updatedCartItems
        .map(item => {
            const rate = parseFloat(item?.tax_rate);
            return isNaN(rate) ? 0 : rate;
        })
        .filter(rate => rate > 0);
    const maxTaxRate = taxRates.length > 0 ? Math.max(...taxRates) : 0;
    const totalTax = subtotal > 0 && maxTaxRate > 0 ? (subtotal * maxTaxRate) / 100 : 0;

    // Calculate updated total
    const total = subtotal + totalTax - (discount || 0) + (state.posOrder?.delivery_charge || 0);

    state = Object.assign({}, state, {
        posOrder: {
            ...state.posOrder,
            cartItems: updatedCartItems,
            subtotal: parseFloat(subtotal).toFixed(2),
            total_tax: parseFloat(totalTax).toFixed(2),
            total: parseFloat(total).toFixed(2),
            discount: discount,
            delivery_charge: 0,
        },
    });

    return state;
};

const updateOrderPOS = (state, payload) => {
    state = Object.assign({}, state, {
        posOrder: {
            ...state.posOrder,
            ...payload,
        },
    });

    return state;
};

const removeFromCartPOS = (state, payload) => {
    const updatedCartItems = state.posOrder?.cartItems.filter((item, idx) => !(item._id === payload._id && idx === payload.index));

    // Calculate updated subtotal (without tax) - items already have tax_amount = 0
    const subtotal = updatedCartItems.reduce((sum, item) => {
        return sum + (item.total_price || 0);
    }, 0);
    
    // Calculate tax on total subtotal using the highest tax rate from items
    const taxRates = updatedCartItems
        .map(item => {
            const rate = parseFloat(item?.tax_rate);
            return isNaN(rate) ? 0 : rate;
        })
        .filter(rate => rate > 0);
    const maxTaxRate = taxRates.length > 0 ? Math.max(...taxRates) : 0;
    const totalTax = subtotal > 0 && maxTaxRate > 0 ? (subtotal * maxTaxRate) / 100 : 0;

    // Calculate updated total
    const total = subtotal + totalTax - (state.posOrder?.discount || 0) + (state.posOrder?.delivery_charge || 0);

    state = Object.assign({}, state, {
        posOrder: {
            ...state.posOrder,
            cartItems: updatedCartItems,
            subtotal: parseFloat(subtotal).toFixed(2),
            total_tax: parseFloat(totalTax).toFixed(2),
            total: parseFloat(total).toFixed(2),
            discount: 0,
            delivery_charge: 0,
        },
    });
    return state;
};

const removeOrderPOS = (state, payload) => {
    state = Object.assign({}, state, {
        posOrder: {
            token: '',
            user_id: '',
            subtotal: 0,
            total_tax: 0,
            discount: 0,
            delivery_charge: 0,
            total: 0,
            order_type: 1,
            payment_method_id: '',
            dining_table_id: '',
            cartItems: [],
        },
    });
    return state;
};

// table order
const addOrUpdateCartItemTable = (state, payload) => {
    const existingItemIndex =
        state.tableOrder?.cartItems &&
        state.tableOrder?.cartItems.length > 0 &&
        state.tableOrder?.cartItems?.findIndex(
            (item) =>
                item._id === payload._id &&
                JSON.stringify(item?.item_variations?._ids?.sort()) === JSON.stringify(payload?.item_variations?._ids?.sort()) &&
                JSON.stringify(item?.item_extras?._ids?.sort()) === JSON.stringify(payload?.item_extras?._ids?.sort())
        );

    if (state.tableOrder?.cartItems && state.tableOrder?.cartItems.length > 0 && existingItemIndex !== -1) {
        // Update quantity if item already exists in the cart
        const updatedCartItems = state.tableOrder?.cartItems.map((item, index) => {
            if (index === existingItemIndex) {
                const basePrice = (item?.price || 0) + (item?.item_variation_total || 0) + (item?.item_extra_total || 0);
                const updatedQuantity = item?.quantity + 1;
                const totalPrice = basePrice * updatedQuantity;

                return {
                    ...item,
                    quantity: updatedQuantity,
                    total_price: totalPrice,
                };
            }
            return item;
        });

        const subtotal = updatedCartItems.reduce((sum, item) => sum + (item.total_price || 0), 0);
        const total = subtotal - (state.tableOrder?.discount || 0) + (state.tableOrder?.delivery_charge || 0);

        state = Object.assign({}, state, {
            tableOrder: {
                ...state.tableOrder,
                cartItems: updatedCartItems,
                subtotal: parseFloat(subtotal).toFixed(2),
                total: parseFloat(total).toFixed(2),
                discount: 0,
                delivery_charge: 0,
            },
        });
    } else {
        // Add new item to the cart
        state = Object.assign({}, state, {
            tableOrder: {
                ...state.tableOrder,
                cartItems: [...(state.tableOrder?.cartItems || []), { ...payload }],
            },
        });

        // Calculate subtotal, total tax, and total
        const subtotal = state.tableOrder.cartItems.reduce((sum, item) => sum + (item.total_price || 0), 0);
        const total = subtotal - (state.tableOrder?.discount || 0) + (state.tableOrder?.delivery_charge || 0);

        // Update state with recalculated values
        state = Object.assign({}, state, {
            tableOrder: {
                ...state.tableOrder,
                subtotal: parseFloat(subtotal).toFixed(2),
                total: parseFloat(total).toFixed(2),
                discount: 0,
                delivery_charge: 0,
            },
        });
    }

    return state;
};

const updateCartItemQuantityTable = (state, payload) => {
    const existingItemIndex = state.tableOrder?.cartItems.findIndex((item, index) => item._id === payload._id && index === payload.index);
    const existingItem = state.tableOrder?.cartItems.find((item, index) => item._id === payload._id && index === payload.index);
    let updatedCartItems = '';
    if (existingItemIndex !== -1 && existingItem.quantity && payload?.quantity && existingItem.quantity < payload?.quantity) {
        // Update quantity if item already exists in the cart
        updatedCartItems = state.tableOrder?.cartItems.map((item, index) => {
            if (index === existingItemIndex) {
                const basePrice = (item?.price || 0) + (item?.item_variation_total || 0) + (item?.item_extra_total || 0);
                const updatedQuantity = item?.quantity + 1;
                const totalPrice = basePrice * updatedQuantity;

                return {
                    ...item,
                    quantity: updatedQuantity,
                    total_price: totalPrice,
                };
            }
            return item;
        });
    } else if (existingItemIndex !== -1 && existingItem.quantity && payload?.quantity && existingItem.quantity > payload?.quantity) {
        updatedCartItems = state.tableOrder?.cartItems.map((item, index) => {
            if (index === existingItemIndex) {
                const basePrice = (item?.price || 0) + (item?.item_variation_total || 0) + (item?.item_extra_total || 0);
                const updatedQuantity = item?.quantity - 1;
                const totalPrice = basePrice * updatedQuantity;

                return {
                    ...item,
                    quantity: updatedQuantity,
                    total_price: totalPrice,
                };
            }
            return item;
        });
    }

    const subtotal = updatedCartItems.reduce((sum, item) => sum + (item.total_price || 0), 0);
    const total = subtotal - (state.tableOrder?.discount || 0) + (state.tableOrder?.delivery_charge || 0);

    state = Object.assign({}, state, {
        tableOrder: {
            ...state.tableOrder,
            cartItems: updatedCartItems,
            subtotal: parseFloat(subtotal).toFixed(2),
            total: parseFloat(total).toFixed(2),
            discount: 0,
            delivery_charge: 0,
        },
    });
    return state;
};

const updateOrderTable = (state, payload) => {
    state = Object.assign({}, state, {
        tableOrder: {
            ...state.tableOrder,
            ...payload,
        },
    });

    return state;
};

const removeFromCartTable = (state, payload) => {
    console.log(state, payload);

    const updatedCartItems = state.tableOrder?.cartItems.filter((item, idx) => !(item._id === payload._id && idx === payload.index));
    console.log(updatedCartItems);
    // Calculate updated subtotal and total_tax
    const subtotal = updatedCartItems.reduce((sum, item) => sum + (item.total_price || 0), 0);

    // Calculate updated total
    const total = subtotal - (state.tableOrder?.discount || 0) + (state.tableOrder?.delivery_charge || 0);

    state = Object.assign({}, state, {
        tableOrder: {
            ...state.tableOrder,
            cartItems: updatedCartItems,
            subtotal: parseFloat(subtotal).toFixed(2),
            total: parseFloat(total).toFixed(2),
            discount: 0,
            delivery_charge: 0,
        },
    });
    return state;
};

const removeOrderTable = (state, payload) => {
    state = Object.assign({}, state, {
        tableOrder: {
            token: '',
            user_id: '',
            subtotal: 0,
            discount: 0,
            delivery_charge: 0,
            total: 0,
            order_type: 1,
            payment_method_id: '',
            dining_table_id: '',
            cartItems: [],
        },
    });
    return state;
};

export default GeneralSetting;
